import type { ValueGetterParams } from 'ag-grid-community'

import type { ColDef } from 'ag-grid-community'
import type { SupplierConfig } from '../../../../api/useSupplierReconciliation'
import { InvoiceHoldColumn } from './renderers/InvoiceHoldColumn'
import { MappingStatusCell } from './renderers/MappingStatusCell'
import { ConfigStatusCell } from './renderers/ConfigStatusCell'
import { UserAssignmentCell } from './renderers/UserAssignmentCell'
import UserSelectEditor from './editors/UserSelectEditor'

export function getSupplierConfigColumns(): ColDef<SupplierConfig>[] {
  return [
    {
      headerName: 'Invoice Hold',
      field: 'hold',
      flex: 0.5,
      cellRenderer: InvoiceHoldColumn,
      editable: false,
    },
    {
      headerName: 'Config Status',
      field: 'auto_match_rules',
      flex: 0.5,
      valueGetter: (params: ValueGetterParams<SupplierConfig>) => {
        if (params.data?.auto_match_rules || params.data?.auto_approve_rules || params.data?.warning_rules) {
          return 'Custom'
        }
        return 'Global'
      },
      cellRenderer: ConfigStatusCell,
      editable: false,
    },
    {
      headerName: 'Supplier',
      field: 'supplier_name',
      sort: 'asc',
      flex: 1,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'External Mappings',
      field: 'external_name_mappings',
      editable: false,
      flex: 1,
      cellRenderer: MappingStatusCell,
    },

    {
      headerName: 'Assigned To',
      field: 'assignee_username',
      valueGetter: (params: ValueGetterParams<SupplierConfig>) =>
        params.data?.assignee_username || params.data?.assignee?.username,
      cellRenderer: UserAssignmentCell,
      cellEditor: UserSelectEditor,
      cellEditorPopup: true,
      editable: true,
    },
  ]
}
